// extracted by mini-css-extract-plugin
export default {"font-renta":"Groups_font-renta__aVcKa","groups":"Groups_groups__r+Giu","toolbar":"Groups_toolbar__IILDF"};